import { render, staticRenderFns } from "./BotTricksTable.vue?vue&type=template&id=661ba280&scoped=true&"
import script from "./BotTricksTable.vue?vue&type=script&lang=js&"
export * from "./BotTricksTable.vue?vue&type=script&lang=js&"
import style0 from "./BotTricksTable.vue?vue&type=style&index=0&id=661ba280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ba280",
  null
  
)

export default component.exports